// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__xdt2T","LogoText":"Logo_LogoText__1jqkL"};